"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vuex_1 = require("vuex");
const vue_property_decorator_1 = require("vue-property-decorator");
const wltp_modal_vue_1 = tslib_1.__importDefault(require("@/components/wltp-modal/wltp-modal.vue"));
let Footnote = class Footnote extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        /**
         * State properties
         */
        this.WLTPModalStatus = false;
    }
    /**
     * Methods
     */
    toggleWLTPModal() {
        this.WLTPModalStatus = !this.WLTPModalStatus;
    }
};
Footnote = tslib_1.__decorate([
    (0, vue_property_decorator_1.Component)({
        name: 'Footnote',
        components: { WltpModal: wltp_modal_vue_1.default },
        computed: Object.assign({}, (0, vuex_1.mapGetters)(['outputsConfig', 'disclaimers'])),
    })
], Footnote);
exports.default = Footnote;
